export default __webpack_public_path__ + "d59efffba368a66c1ace477c7e000eb5.svg";